<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}个{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small"
            v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" type="danger" size="small" :disabled="multiple"
            v-preventReClick @click="handleDelete">
            删除
          </el-button>

          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
          @click="showTransfer">自定义设置</el-button>
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <div v-if="tableHaeder.length>0">
        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
          <template slot="before">
            <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
            </el-table-column>
          </template>
          <template slot="after">
            <el-table-column prop="operation" fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
                <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)" type="text"
                  v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
                <el-button v-else-if="scope.row.status != 1 && tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick
                  @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
                <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick
                  @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
              </template>
            </el-table-column>
          </template>
        </CustomTable>
      </div>
     <div v-else>
      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight"
      style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
      <template slot="empty">
        <div class="empty-div" :style="{ height: tableHeight + 'px' }">
          <img src="../../../../assets/noData.png" width="240" height="240" />
          <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
          <div class="empty-rest" @click="reset">恢复默认</div>
        </div>
      </template>
      <el-table-column fixed type="selection" :reserve-selection="true" width="55" align="center"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="100" prop="warehouseName" label="库房名称"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="140" prop="supplierProductNo"
        label="供应商产品编码"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="120" prop="productName" label="产品名称"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="140" prop="specName" label="规格型号"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="80" prop="minUnit" label="最小单位"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="140" prop="manufacturerName" label="生产厂家"></el-table-column>
      <el-table-column prop="max" label="库存上限"></el-table-column>
      <el-table-column prop="safeStock" label="安全库存"></el-table-column>
      <el-table-column prop="min" label="库存下限"></el-table-column>
      <el-table-column prop="warnNames" label="通知人" width="120"></el-table-column>
      <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码"
        width="200"></el-table-column>
      <el-table-column prop="createdTime" label="创建时间" width="170">
        <template slot-scope="scope">
          {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
        </template>
      </el-table-column>
      <el-table-column prop="updateUserName" label="最后修改人" width="120"></el-table-column>
      <el-table-column label="最后修改时间" width="170">
        <template slot-scope="scope">
          {{ parseTime(new Date(scope.row.updateTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
        </template>
      </el-table-column>
      <el-table-column v-if="isWorkflowTable" label="审批人" width="180" align="center" prop="approverNames" />
      <el-table-column prop="statusName" label="流程状态" width="80" v-if="isWorkflowTable">
        <template slot-scope="scope">
          <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions"
            @success="getData" :tableCode="route.name"></approve-status>
        </template>
      </el-table-column>

      <el-table-column prop="operation" fixed="right" label="操作" width="180">
        <template slot-scope="scope">
          <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
          <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)" type="text"
            v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
          <el-button v-else-if="scope.row.status != 1 && tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick
            @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick
            @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>
  

      <el-dialog :title="title + route.menuName" :visible.sync="open" :center="true" width="1100px"
        :before-close="cancel" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
          <el-row>
            <el-col :span="24">
              <span style="color: red" v-if="editMode">如果需设置自动申领，请慎重填写库存上限、下限和安全库存值</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="warehouseName" label="库房">
                  <el-select :disabled="!editMode" v-model="form.warehouseName" style="width: 100%" filterable placeholder="请选择入库库房" :filter-method="getWarehouses" @change="warehouseChange">
                  <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                     </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="supplierProductId" label="供货商产品">
                <!-- :dataList="STATIC_SupplierProducts" -->
                <!-- <SelectTable :disabled="!editMode" :columns="supplierProductColumns" :placeholder="'请选择产品'" :innerName="form.productName" :dataList="STATIC_SupplierProducts" @querySubmit="getProductList" @change="productChange" :filterable="false" :filterOptions="supplierProductFilterOptions" /> -->
                <SelectScrollTable :disabled="!editMode" :innerName="form.productName" :columns="supplierProductColumns"
                  style="width: 100%" :filterMethod="GetSupplierProducts" :otherQuery="productQuery"
                  @change="productChange">
                </SelectScrollTable>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="supplierProductNo" label="供货商产品编码">
                <el-input disabled v-model="form.supplierProductNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="specName" label="规格型号">
                <el-input disabled v-model="form.specName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="manufacturerName" label="生产厂家">
                <el-input disabled v-model="form.manufacturerName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="minUnit" label="最小单位">
                <el-input disabled v-model="form.minUnit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="packSpec" label="包装规格">
                <el-input disabled v-model="form.packSpec"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="max" label="库存上限">
                <el-input-number :disabled="!editMode" :min="1" :controls="false" v-model="form.max"
                  placeholder="请输入库存上限" style="width: 100%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="min" label="库存下限">
                <el-input-number :disabled="!editMode" :min="1" :controls="false" v-model="form.min"
                  placeholder="请输入库存下限" style="width: 100%"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="safeStock" label="安全库存">
                <el-input-number :disabled="!editMode" :min="1" :controls="false" v-model="form.safeStock"
                  placeholder="请输入安全库存" style="width: 100%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="medicalInsuranceCategoryNo" label="医保代码">
                <el-input disabled v-model="form.medicalInsuranceCategoryNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="warnIds" label="库存提醒对象">
                <el-select v-model="form.warnIdArr" :disabled="!editMode" multiple filterable :filter-method="getUsers"
                  @change="userChange" placeholder="请选择库存提醒对象" style="width: 100%">
                  <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.no + ' ' + item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注">
                <el-input :disabled="!editMode" v-model="form.remark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
          <el-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</el-button>
          <el-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确
            定</el-button>
          <el-button v-if="!editMode" class="btn default" v-preventReClick @click="open = false">返 回</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import {
  SaveInventoryWarning,
  RemoveInventoryWarning,
  GetInventoryWarnings,
  GetInventoryWarningById,
  RejectInventoryWarning,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
// import SelectTable from "@/components/select-table";
import SelectScrollTable from "@/components/select-scroll-table";
import SelectFilter from "@/components/table-select-filter";
import ApproveInfo from "@/components/approve-info";
import { ApproveStatusOptions } from "@/enum";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    // SelectTree
    // SelectTable,
    SelectFilter,
    ApproveInfo,
    SelectScrollTable,
  },
  data () {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId(),
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      editMode: false,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      ApproveStatusOptions: ApproveStatusOptions,
      rules: {
        warehouseName: [{ required: true, message: "请选择库房", trigger: "blur" }],
        min: [
          { required: true, message: "请输入库存下限", trigger: "blur" },
          { validator: this.validateMin, trigger: "blur" },
        ],
        max: [
          { required: true, message: "请输入库存上限", trigger: "blur" },
          { validator: this.validateMax, trigger: "blur" },
        ],
        safeStock: [
          { required: true, message: "请输入安全库存", trigger: "blur" },
          { validator: this.validateSafeStock, trigger: "blur" },
        ],
        supplierProductId: [
          { required: true, message: "请选择供应商产品", trigger: "blur" },
        ],
        warnIds: [{ required: true, message: "请选择库存提醒对象", trigger: "blur" }],
      },
      filterOptions: [
        {
          name: "库房",
          type: "select",
          code: "warehouseId",
          filterMethod: this.getWarehouses,
          data: [],
        },
        {
          name: "供应商产品",
          type: "select",
          code: "supplierProductId",
          filterMethod: this.getSupplierProductsNoDebounce,
          data: [],
        },
        {
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo",
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName",
        },
        {
          name: "规格型号",
          type: "input",
          code: "specName",
        },
        {
          name: "生产厂家",
          type: "input",
          code: "manufacturerName",
        },
        {
          name: "流程状态",
          type: "select",
          code: "statuses",
          multiple: true,
          data: ApproveStatusOptions,
        },
      ],
      reject: RejectInventoryWarning,

      productQuery: {
        isEnabled: 1,
        status: 2,
      },
    };
  },
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
    },
    // 获取列表
    getData () {
      this.loading = true;
      GetInventoryWarnings(this.query)
        .then((res) => {
          this.tableData = res.returnData.data;
          this.total = res.returnData.totalCount;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 新建
    handleAdd () {
      this.open = true;
      this.title = "新建";
      this.resetForm();
      this.editMode = true;
      this.showWorkFlowInfo = false;
    },
    handleInfo (row) {
      GetInventoryWarningById({ id: row.id }).then((res) => {
        this.resetForm();
        this.form = res.returnData;
        this.open = true;
        this.editMode = false;

        if (res.returnData.warnInfos) {
          this.$set(
            this.form,
            "warnIdArr",
            res.returnData.warnInfos.map((item) => item.id)
          );
          res.returnData.warnInfos.map((item) => {
            var user = this.STATIC_Users.filter((e) => e.id == item.id);
            if (!user || user.length == 0) {
              this.STATIC_Users.push(item);
            }
          });
        }
        this.initWorkFlowProperty(this.form);
      });
    },
    // 编辑
    handleUpdate (row) {
      GetInventoryWarningById({ id: row.id }).then((res) => {
        this.resetForm();
        this.form = res.returnData;
        this.open = true;
        this.title = "编辑";

        if (res.returnData.warnInfos) {
          this.$set(
            this.form,
            "warnIdArr",
            res.returnData.warnInfos.map((item) => item.id)
          );
          res.returnData.warnInfos.map((item) => {
            var user = this.STATIC_Users.filter((e) => e.id == item.id);
            if (!user || user.length == 0) {
              this.STATIC_Users.push(item);
            }
          });
        }
        this.initWorkFlowProperty(this.form);

        this.editMode = true;
      });
    },
    handleApprove (row) {
      GetInventoryWarningById({ id: row.id }).then((res) => {
        this.resetForm();
        this.form = res.returnData;
        this.open = true;
        this.editMode = false;
        this.title = "编辑";

        if (res.returnData.warnInfos) {
          this.$set(
            this.form,
            "warnIdArr",
            res.returnData.warnInfos.map((item) => item.id)
          );
          res.returnData.warnInfos.map((item) => {
            var user = this.STATIC_Users.filter((e) => e.id == item.id);
            if (!user || user.length == 0) {
              this.STATIC_Users.push(item);
            }
          });
        }

        this.showWorkFlowInfo = this.isShowApproveButton(this.form.approverIds);
      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SaveInventoryWarning(this.form)
          .then((res) => {
            this.open = false;
            this.$my_message(`执行成功`, "success");
            this.getData();
          })
          .finally(() => {
          this.$store.dispatch('SetLoading',false)
        });
      });
    },
    resetForm () {
      
      this.form = {
        id: 0,
        warehouseName:'',
        // deptName:!this.userInfo.isAdmin?this.mySessionStorage.getDeptName():'',
        // deptId: !this.userInfo.isAdmin?this.mySessionStorage.getDeptId():'' ,
        deptName:'',
        deptId:'',
        supplierProductId: "",
        stockCategory: 0,
        remark: "",
        productName: "",
        productId: "",
        warnIdArr: [],
        min: 0,
        max: 0,
        safeStock: 0,
        warnIds: [],
        orgCode :sessionStorage.getItem('orgId')
      };
      if(!this.userInfo.isAdmin){
        // let DeptName =  this.mySessionStorage.getDeptName()?this.mySessionStorage.getDeptName():''
        // let WardName = this.mySessionStorage.getWardName()?this.mySessionStorage.getWardName():''
        
        // this.form.deptName = this.system_setting.IsUseWard?`${DeptName} ${WardName} `:DeptName
        // this.form.deptId = this.mySessionStorage.getDeptId()
        // this.form.wardId = this.system_setting.IsUseWard?this.mySessionStorage.getWardId():''
        this.form.warehouseName = this.mySessionStorage.getWarehouseName()
        this.form.warehouseId = this.mySessionStorage.getWarehouseId()
      }else{
        this.form.deptName = ''
        this.form.deptId = ''
      }
      this.getWarehouses('')
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      if (this.editMode) {
        this.$my_confirm("确认要中断当前操作吗？", "提示", {
          type: "warning",
        })
          .then(() => {
            this.open = false;
          })
          .catch(() => { });
      } else {
        this.open = false;
      }
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },

    // 删除部门
    handleDelete (row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("此操作将删除数据, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          return RemoveInventoryWarning({ ids });
        })
        .then(() => {
          this.$my_message(`删除成功`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId(),
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = [];
      this.multipleSelection = [];
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    filterChange (query) {
      window.console.log(query);
      this.query = Object.assign(this.query, query);
      this.getData();
    },

    productChange (row) {
      let id = this.form.id;
      this.form = Object.assign(this.form, row);
      this.form.id = id;
      this.form.supplierProductId = row.id;
      this.form.supplierProductNo = row.no;
      this.form.remark = "";

      this.$refs.form.validateField("supplierProductId");
    },
    warehouseChange (val) {
      let item = this.STATIC_Warehouses.find((e) => e.id == val);
      if (item) {
        this.form.warehouseId = item.id;
      }
    },

    deptChange (val) {
      this.form.deptId = val;
    },
    applyDeptChange1(val){
      let arr = this.STATIC_Depts.filter(res=>res.idGroup == val)
      this.form.deptName =  arr[0].deptName + " " + (arr[0].wardName?arr[0].wardName:'');
      this.form.deptId = arr[0].deptId
      this.form.wardId = arr[0].wardId
      console.log( this.form);
      this.$forceUpdate()
      // this.getWarehouseList("");
    },
    userChange (val) {
      this.form.warnIds = val.join(";");
    },

    getProductList (keyWord) {
      // query.isEnabled = 1
      // query.status = 2
      // query.pageIndex = 1
      // query.pageSize = 50
      this.getSupplierProducts(
        //query)
        {
          keyWord: keyWord,
          isEnabled: 1,
          status: 2,
        }
      );
    },

    validateMin (rule, value, callback) {
      if (value) {
        var max = this.form.max;
        if (value > max) {
          callback(new Error("库存下限不能高于库存上限"));
        }
        callback();
      }
    },
    validateMax (rule, value, callback) {
      if (value) {
        var min = this.form.min;
        if (min > value) {
          callback(new Error("库存上限不能低于库存下限"));
        }
        callback();
      }
    },
    validateSafeStock (rule, value, callback) {
      if (value) {
        var min = this.form.min;
        var max = this.form.max;
        if (value < min || value > max) {
          callback(new Error("安全库存不能高于库存上限并且不能低于库存下限"));
        }
        callback();
      }
    },
  },
  mounted () {
    this.getData();
    this.getUsers("");
   
    this.getProductList("");
  },
};
</script>

<style lang="scss" scoped></style>
